export default "__VITE_ASSET__O2RcMB1o__"